import api from './api'

type ApiSuccessResponse<T> = {
  success?: boolean
  data: T
}

export interface Category {
  id: string
  name: string
  slug: string
  description?: string
  imageUrl?: string
  isActive: boolean
  sortOrder: number
}

type CategoriesListResponse = {
  categories: Category[]
}

const categoryService = {
  /**
   * Lista todas as categorias ativas (endpoint público GET /api/categories).
   */
  async list(): Promise<Category[]> {
    try {
      const response = await api.get<ApiSuccessResponse<CategoriesListResponse>>(
        '/categories'
      )
      return response.data.data?.categories ?? []
    } catch (error) {
      console.error('Erro ao buscar categorias:', error)
      return []
    }
  },

  /**
   * Busca uma categoria pelo slug
   */
  async getBySlug(slug: string): Promise<Category | null> {
    const categories = await this.list()
    return categories.find(cat => cat.slug === slug) || null
  }
}

export default categoryService

